module.exports = __webpack_public_path__ + "media/login.cf5a8401.mp4";